<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-card-title class="kahon">
        <strong class="subheading"
          >Get connected with us on social networks!</strong
        >

        <v-spacer></v-spacer>

        <v-btn v-for="icon in icons" :key="icon" class="mx-4" dark icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center">
        {{ new Date().getFullYear() }} — <strong>Kahon Storage Inc.</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "footerComponent",

  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
    accordion: true,
    focusable: true,
    faqs: [
      {
        question: "What is Kahon.ph?",
        answer:
          "Kahon.ph is the only serviced storage company in the Philippines. Unlike traditional self-storage companies, we’ve integrated handling and logistics so that you have the most pleasant storage experience possible. This means that you never go to the storage facility -- you simply manage your items through our website and decide what you want to store and what you want returned.",
      },
      {
        question: "How do I store with Kahon.ph?",
        answer:
          "Storing is easy. You first create an account at https://kahon.ph. After creating an account, you choose which storage solution best fits your needs best. Our storage options can be classified into two more general types -- KAHON (by-the-box) for smaller items, and KWARTO (by-the-square-meter) for larger items that won’t fit in our boxes.",
      },
      {
        question: "Which area does Kahon.ph serve?",
        answer:
          "We currently service the Greater Manila Area, with plans of expanding. Do let us know if you want Kahon.ph to serve your area. The more of you there are in a general area the quicker we can help!",
      },
      {
        question: "What is your minimum storage period?",
        answer:
          "Minimum storage period for Kahon is 3 months, while for Kwarto is 1 month. If you wish to store for a shorter time, please do let us know and we’ll try our best to accommodate your requirement.",
      },
    ],
  }),
};
</script>
